export const dashboardEase = [0.25, 0.46, 0.45, 0.94]

export const revealTransition = {
  duration: 0.35,
  ease: dashboardEase
}

export const routeTransition = {
  duration: 0.24,
  ease: dashboardEase
}

export const panelTransition = {
  duration: 0.2,
  ease: dashboardEase
}

export const tabIndicatorTransition = {
  type: 'spring',
  stiffness: 500,
  damping: 34
}
